export var Audience;
(function (Audience) {
    Audience["ANNOTATION_PLATFORM"] = "ap";
    Audience["CMP_PLATFORM"] = "cmp";
})(Audience || (Audience = {}));
export var UserRole;
(function (UserRole) {
    UserRole["ORGANIZATION_USER"] = "organization_user";
    UserRole["ORGANIZATION_ADMIN"] = "organization_admin";
    UserRole["PROJECT_MANAGEMENT_OFFICER"] = "project_management_officer";
    UserRole["SAAS_ADMIN"] = "saas_admin";
    UserRole["SYSTEM_ADMIN"] = "system_admin";
    UserRole["CONTRIBUTOR"] = "contributor";
    UserRole["EMPLOYEE"] = "employee";
    UserRole["TESTING_MANAGER"] = "testing_manager";
    UserRole["SOURCING"] = "sourcing";
    UserRole["SOURCING_MANAGER"] = "sourcing_manager";
    UserRole["PRODUCTION"] = "production";
})(UserRole || (UserRole = {}));
export var MembershipType;
(function (MembershipType) {
    MembershipType["ORGANIZATION"] = "organization";
})(MembershipType || (MembershipType = {}));
export var Permission;
(function (Permission) {
    Permission["READ_ORGS"] = "read:organizations";
    Permission["CREATE_ORGS"] = "create:organizations";
    Permission["UPDATE_ORGS"] = "update:organizations";
    Permission["UPDATE_PROFILE"] = "update:profile";
    Permission["INVITE_USER_ORGS"] = "invite_users:organizations";
    Permission["READ_USERS"] = "read:users";
    Permission["UPDATE_USERS"] = "update:users";
    Permission["CREATE_API_CLIENTS"] = "create:api_clients";
    Permission["READ_API_CLIENTS"] = "read:api_clients";
    Permission["UPDATE_API_CLIENTS"] = "update:api_clients";
    Permission["READ_PROJECTS"] = "read:projects";
    Permission["CREATE_PROJECTS"] = "create:projects";
    Permission["UPDATE_PROJECTS"] = "update:projects";
    Permission["WORK_PROJECTS"] = "work:projects";
    Permission["DOWNLOAD_PROJECTS"] = "download:projects";
    Permission["READ_ASSESSMENTS"] = "read:assessments";
    Permission["CREATE_ASSESSMENTS"] = "create:assessments";
    Permission["UPDATE_ASSESSMENTS"] = "update:assessments";
    Permission["CREATE_PRINCIPAL_PROJECT"] = "create:principal_projects";
    Permission["READ_PRINCIPAL_PROJECT"] = "read:principal_projects";
    Permission["UPDATE_PRINCIPAL_PROJECT"] = "update:principal_projects";
    Permission["CREATE_SUPPORT_TICKETS"] = "create:support_tickets";
    Permission["WORK_ASSESSMENTS"] = "work:assessments";
    Permission["DOWNLOAD_ASSESSMENTS"] = "download:assessments";
    Permission["ASSESSMENT_ELIGIBILITY_CRITERIA_CREATE"] = "create:assessment_eligibility_criteria";
    Permission["ASSESSMENT_ELIGIBILITY_CRITERIA_READ"] = "read:assessment_eligibility_criteria";
    Permission["ASSESSMENT_ELIGIBILITY_CRITERIA_UPDATE"] = "update:assessment_eligibility_criteria";
    Permission["WORKSHEET_READ"] = "read:worksheets";
    Permission["WORKSHEET_ENTRY_CREATE"] = "create:worksheet_entries";
    Permission["WORKSHEET_SUBMIT"] = "submit:worksheets";
    Permission["WORKSHEET_APPROVE"] = "approve:worksheets";
    Permission["WORKSHEET_REOPEN"] = "reopen:worksheets";
    Permission["SUBMIT_JOB_POSTS_APPLICATIONS"] = "submit:job_posts_applications";
    Permission["READ_JOB_POSTS_APPLICATIONS"] = "read:job_posts_applications";
    Permission["READ_JOB_POSTS"] = "read:job_posts";
    Permission["READ_JOB_ENTRY_METADATA"] = "read:job_entry_metadata";
    Permission["ORG_CREATE"] = "create:organizations";
    Permission["ORG_READ"] = "read:organizations";
    Permission["ORG_UPDATE"] = "update:organizations";
    Permission["ORG_INVITE_USER"] = "invite_users:organizations";
    Permission["USER_CREATE"] = "create:users";
    Permission["USER_READ"] = "read:users";
    Permission["USER_UPDATE"] = "update:users";
    Permission["USER_DELETE"] = "delete:users";
    Permission["CONTRIBUTOR_USER_READ"] = "read:contributor_users";
    Permission["API_CLIENT_CREATE"] = "create:api_clients";
    Permission["API_CLIENT_READ"] = "read:api_clients";
    Permission["API_CLIENT_UPDATE"] = "update:api_clients";
    Permission["PROFILE_UPDATE"] = "update:profile";
    Permission["PROJECT_CREATE"] = "create:projects";
    Permission["PROJECT_READ"] = "read:projects";
    Permission["PROJECT_UPDATE"] = "update:projects";
    Permission["PROJECT_WORK"] = "work:projects";
    Permission["PROJECT_DOWNLOAD"] = "download:projects";
    Permission["JOB_ENTRY_CREATE"] = "create:job_entries";
    Permission["JOB_ENTRY_READ"] = "read:job_entries";
    Permission["JOB_ENTRY_UPDATE"] = "update:job_entries";
    Permission["JOB_POST_CREATE"] = "create:job_posts";
    Permission["JOB_POST_READ"] = "read:job_posts";
    Permission["JOB_POST_UPDATE"] = "update:job_posts";
    Permission["JOB_POST_APPLICATION_SUBMIT"] = "submit:job_posts_applications";
    Permission["JOB_POST_APPLICATION_READ"] = "read:job_posts_applications";
    Permission["JOB_POST_APPLICATION_UPDATE"] = "update:job_posts_applications";
    Permission["JOB_POST_APPLICATION_UPDATE_STATUS_ONBOARDED"] = "update:job_posts_application_status_onboarded";
    Permission["JOB_POST_APPLICATION_TRANSFER_CANDIDATES"] = "transfer_candidates:job_posts_applications";
    Permission["PRINCIPAL_PROJECT_CREATE"] = "create:principal_projects";
    Permission["PRINCIPAL_PROJECT_READ"] = "read:principal_projects";
    Permission["PRINCIPAL_PROJECT_UPDATE"] = "update:principal_projects";
    Permission["PRINCIPAL_PROJECT_CONTRIBUTOR_ASSIGNMENT_CREATE"] = "create:principal_project_contributor_assignments";
    Permission["PRINCIPAL_PROJECT_CONTRIBUTOR_ASSIGNMENT_READ"] = "read:principal_project_contributor_assignments";
    Permission["PRINCIPAL_PROJECT_CONTRIBUTOR_ASSIGNMENT_UPDATE"] = "update:principal_project_contributor_assignments";
    Permission["PRINCIPAL_PROJECT_METADATA_CREATE"] = "create:principal_project_metadata";
    Permission["PRINCIPAL_PROJECT_METADATA_READ"] = "read:principal_project_metadata";
    Permission["PRINCIPAL_PROJECT_METADATA_UPDATE"] = "update:principal_project_metadata";
    Permission["PRINCIPAL_PROJECT_METADATA_DELETE"] = "delete:principal_project_metadata";
    Permission["SUPPORT_TICKET_CREATE"] = "create:support_tickets";
    Permission["ASSESSMENT_READ"] = "read:assessments";
    Permission["ASSESSMENT_CREATE"] = "create:assessments";
    Permission["ASSESSMENT_UPDATE"] = "update:assessments";
    Permission["ASSESSMENT_WORK"] = "work:assessments";
    Permission["ASSESSMENT_DOWNLOAD"] = "download:assessments";
    Permission["ASSESSMENT_RESTORE_SCORE"] = "restore_score:assessments";
    Permission["SURVEY_CREATE"] = "create:survey";
    Permission["SURVEY_READ"] = "read:survey";
    Permission["SURVEY_UPDATE"] = "update:survey";
    Permission["PIPELINE_CREATE"] = "create:pipeline";
    Permission["PIPELINE_READ"] = "read:pipeline";
    // application rejection reasons
    Permission["REJECTION_REASON_CREATE"] = "create:rejection_reasons";
    Permission["REJECTION_REASON_READ"] = "read:rejection_reasons";
    Permission["JOB_ENTRY_PROJECT_TYPE_CREATE"] = "create:project_type";
    Permission["JOB_ENTRY_PROJECT_SUB_TYPE_CREATE"] = "create:project_sub_type";
    Permission["JOB_ENTRY_PROJECT_TYPE_UPDATE"] = "update:project_type";
    Permission["JOB_ENTRY_PROJECT_SUB_TYPE_UPDATE"] = "update:project_sub_type";
    Permission["JOB_ENTRY_PROJECT_TYPE_READ"] = "read:project_types";
    Permission["JOB_ENTRY_PROJECT_SUB_TYPE_READ"] = "read:project_sub_types";
    Permission["JOB_ENTRY_PROJECT_TYPE_DELETE"] = "delete:project_types";
    Permission["JOB_ENTRY_PROJECT_SUB_TYPE_DELETE"] = "delete:project_sub_types";
    Permission["FLAMINGO_IP_ALERTS_READ"] = "read:ip_alerts";
    Permission["JOB_ENTRY_JOB_POSTS_READ"] = "read:job_posts";
    Permission["JOB_ENTRY_JOB_POSTS_CREATE"] = "create:job_posts";
    Permission["JOB_ENTRY_JOB_POSTS_UPDATE"] = "update:job_posts";
    Permission["JOB_ENTRY_METADATA_READ"] = "read:job_entry_metadata";
    Permission["JOB_POST_APPLICATION_READ_SELECTED"] = "read:selected_job_posts_applications";
    Permission["JOB_POST_APPLICATION_READ_IN_PROGRESS"] = "read:in_progress_job_posts_applications";
    Permission["FILE_INFORMATION_UPLOAD"] = "create:file_information";
    Permission["FILE_INFORMATION_DELETE"] = "delete:file_information";
    Permission["FILE_INFORMATION_DOWNLOAD"] = "read:file_information";
    // Accessing applications
    Permission["SQUIRREL_ACCESS"] = "access:squirrel";
    Permission["SOURCING_ACCESS"] = "access:sourcing";
    Permission["ADMIN_ACCESS"] = "access:admin";
    Permission["SUPPORT_TOOLS_ACCESS"] = "access:support_tools";
    Permission["SOURCING_DASHBOARD_ACCESS"] = "access:sourcing_dashboard";
    Permission["CONTRIBUTORS_LIST_ACCESS"] = "access:contributors_list";
    // manage locales
    Permission["LOCALE_READ"] = "read:locales";
    Permission["LOCALE_UPDATE"] = "update:locales";
    // Process Ceased Requested
    Permission["ASSIGNMENTS_PROCESS_CEASED_REQUESTS"] = "assignments:process_ceased_requests";
})(Permission || (Permission = {}));
export var BioAuthTrigger;
(function (BioAuthTrigger) {
    BioAuthTrigger["ON_LOGIN"] = "on_login";
})(BioAuthTrigger || (BioAuthTrigger = {}));
export var CmpRole;
(function (CmpRole) {
    CmpRole["CONTRIBUTOR"] = "Contributor";
    CmpRole["SOURCING"] = "Sourcing";
    CmpRole["PRODUCTION"] = "Production";
    CmpRole["ADMIN"] = "Admin";
    CmpRole["SYSTEM"] = "System";
    CmpRole["FINANCE"] = "Finance";
    CmpRole["PAYMENT"] = "Payment";
})(CmpRole || (CmpRole = {}));
export var ApiErrorCode;
(function (ApiErrorCode) {
    // CMP OFAC error
    ApiErrorCode["CmpOfacError"] = "Px00071";
})(ApiErrorCode || (ApiErrorCode = {}));
export var LoginError;
(function (LoginError) {
    LoginError["OFACNonCompliant"] = "non_compliant";
    LoginError["NonAuthorized"] = "non_authorized";
})(LoginError || (LoginError = {}));
